

/* @ngInject */
export default function fileread($rootScope, $window) {
    return {
        scope: {
            fileread: '=',
            filereadTypes: '=?',
        },
        link(scope, element, attrs) {
            const fileTypes = (scope.filereadTypes === null || scope.filereadTypes === undefined) ? ['jpg', 'jpeg', 'png', 'gif', 'tiff', 'bmp'] : scope.filereadTypes;
            const maxSize = 10 * (1024 * 1024); // 10 MB

            element.bind('change', (changeEvent) => {
                if (changeEvent.target.files && changeEvent.target.files[0]) {
                    const extension = changeEvent.target.files[0].name.split('.').pop().toLowerCase();
                    const isValidExtension = fileTypes.indexOf(extension) > -1;

                    if (isValidExtension) {
                        const fileSize = changeEvent.target.files[0].size / maxSize;
                        if (fileSize <= 1) {
                            const reader = new $window.FileReader();
                            reader.onload = function (loadEvent) {
                                scope.$apply(() => {
                                    scope.fileread = loadEvent.target.result;
                                });
                            };
                            reader.readAsDataURL(changeEvent.target.files[0]);
                            const formData = new $window.FormData();
                            //								formData.append("Payload", "{'ContractorId':" + $stateParams.accountId + "}");
                            formData.append('uploadFile', changeEvent.target.files[0]);

                            $rootScope.$broadcast(`${attrs.source}StartUpload`, formData);
                        } else {
                            $rootScope.$apply(() => {
                                $rootScope.$broadcast(`${attrs.source}InvalidUploadSize`);
                            });
                        }
                    } else {
                        $rootScope.$apply(() => {
                            $rootScope.$broadcast(`${attrs.source}InvalidUploadType`, { fileType: extension });
                        });
                    }
                }
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/fileread.directive.js